import React from 'react';
import InterSitial from '../intersitial';
import Icon from '../icon';
import PhoneIcon from '../phoneCall/icon';
import { EventAction } from '../../../../services/ga-enums-interfaces';

export interface SocialNetwork {
	name: string;
	link: string;
}

const SocialNetworks: React.FC<{ items: SocialNetwork[] }> = ({ items }) => {
	const getNetworkIcon = (network: SocialNetwork) => {
		switch (network.name) {
			case 'youtube':
				return (
					<Icon
						key={network.name}
						viewBox=" 0 0 35 24"
						type={network.name}
						className="w-9 text-icon hover:text-icon-hover"
					/>
				);
			case 'phone':
				return (
					<PhoneIcon
						key={network.name} 
						phoneNumber={network.link} 
						action={EventAction.CallUs}
						className="h-7 w-7 text-icon hover:text-icon-hover" 
					/>
				);
			default:
				return (
					<Icon
						key={network.name}
						viewBox=" 0 0 28 28"
						type={network.name}
						className="w-7 text-icon hover:text-icon-hover"
					/>
				);
		}
	};

	return (
		<div data-testid="social" className="flex items-center space-x-5">
			{items.map((network: SocialNetwork) => (
				<>
					{ network.name !== 'phone' 
						? (
							<InterSitial
								link={network.link}
								key={network.name}
								eventLabel={network?.name ? `${network.name} icon` : ''}
								rel="noopener noreferrer"
								target="_blank">
								<span className="sr-only">{network.name}</span>
								{ getNetworkIcon(network) }
							</InterSitial>
						)
						: (
							<>{ getNetworkIcon(network) }</>
						)
					}
				</>
			))}
		</div>
	);
};

export default SocialNetworks;
